export const firebaseConfig = {
    apiKey: "AIzaSyAaK_GfMn_q1Mf1cJvFCeFTLUbs4se6Lew",
    authDomain: "life-dental-care.firebaseapp.com",
    projectId: "life-dental-care",
    storageBucket: "life-dental-care.appspot.com",
    messagingSenderId: "1034058279101",
    appId: "1:1034058279101:web:9a33ec78164569efe5efd4"
};